import { SeoPageLayout } from "@/components/SeoPageLayout";
import { SeoSection } from "@/components/seo/SeoSection";
import { SeoStyledList } from "@/components/seo/SeoStyledList";
import { SeoNumberedSteps } from "@/components/seo/SeoNumberedSteps";

const KomikNaJubileusz = () => (
  <SeoPageLayout title="Komik" titleAccent="na jubileusz firmy">
    <SeoSection title="Jubileusz firmy z humorem">
      <p>5, 10, 25, 50 lat na rynku - każdy jubileusz firmy zasługuje na wyjątkową celebrację. Profesjonalny komik potrafi przerobić historię firmy na fascynujący, zabawny materiał, który wzruszy i rozbawi jednocześnie. To idealny sposób na uhonorowanie przeszłości i rozpoczęcie nowego rozdziału z uśmiechem.</p>
    </SeoSection>

    <SeoSection title="Komediowe podsumowanie lat działalności">
      <p>Każda firma ma swoje legendy, zabawne historie i kultowe sytuacje. Komik zbiera te perełki i tworzy z nich wspaniały materiał komediowy. Od pierwszych dni w garażu, przez kryzysy i sukcesy, po aktualną codzienność - historia firmy opowiedziana z humorem bawi i buduje dumę z przynależności do zespołu.</p>
    </SeoSection>

    <SeoSection title="Format występu jubileuszowego">
      <SeoStyledList items={[
        "Komediowy przegląd historii firmy - dekada po dekadzie",
        "Roast założycieli i kluczowych postaci (za ich zgodą)",
        "Prowadzenie gali jubileuszowej z elementami stand-upu",
        "Interaktywny quiz o historii firmy",
        "Komediowy toast i podsumowanie na zakończenie wieczoru"
      ]} />
    </SeoSection>

    <SeoSection title="Przygotowanie materiału jubileuszowego">
      <SeoNumberedSteps steps={[
        { title: "Wywiady z pracownikami", description: "Przeprowadzamy rozmowy z pracownikami o różnym stażu." },
        { title: "Archiwalia i research", description: "Studiujemy materiały archiwalne i poznajemy historię firmy od podszewki." },
        { title: "Autentyczny występ", description: "Występ pełen szczegółów, które rozpozna każdy pracownik." },
      ]} />
    </SeoSection>
  </SeoPageLayout>
);

export default KomikNaJubileusz;
